import { Injectable } from "@angular/core";
import { ErrorHandler } from "@angular/core";
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    handleError(error: any): void {
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        if (chunkFailedMessage.test(error.message)) {
            if (confirm("Yeni Versiyon Mevcut. Yüklemek İster Misiniz?")) {
                window.location.reload();
            }
        }
    }
}